/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable no-console */
import { NgModule } from '@angular/core';
import { Apollo, ApolloModule } from 'apollo-angular';
import { HttpLink, HttpLinkModule } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { HttpClientModule } from '@angular/common/http';
import { from, ApolloLink } from 'apollo-link';
import { environment } from '../environments/environment';
import { SESSION_CONSTANTS } from './app.constants';
import { StorageService } from './services/storage.service';

@NgModule({
    exports: [
        HttpClientModule,
        ApolloModule,
        HttpLinkModule,
    ],
})
export class GraphQLModule {
    constructor(
        private readonly apollo: Apollo,
        private readonly httpLink: HttpLink,
        private readonly storageService: StorageService
    ) {
        this.apollo.create({
            link: from([
                this.authMiddleware(),
                this.errorAfterware(),
                this.http(),
            ]),
            cache: new InMemoryCache(),
            defaultOptions: {
                watchQuery: { errorPolicy: 'all' },
                mutate: { errorPolicy: 'all' },
                query: { errorPolicy: 'all' },
            },
        });

        this.apollo.createNamed('classMapping', {
            link: from([
                this.authMiddleware(),
                this.errorAfterware(),
                this.httpLink.create({ uri: environment.classMappingUrl }),
            ]),
            cache: new InMemoryCache(),
            defaultOptions: {
                watchQuery: { errorPolicy: 'all' },
                mutate: { errorPolicy: 'all' },
                query: { errorPolicy: 'all' },
            },
        });
    }

    private getTokenFromStorage(): string {
        return this.storageService.getFromSessionStorage(SESSION_CONSTANTS.rbsToken);
    }

    private getUserIdFromStorage(): string {
        return this.storageService.getFromSessionStorage(SESSION_CONSTANTS.identityId);
    }

    private authMiddleware(): ApolloLink {
        return setContext((_, { headers }) => {
            const rbsToken = this.getTokenFromStorage();
            const userId = this.getUserIdFromStorage();
            return {
                headers: {
                    ...headers,
                    authorization: rbsToken ? `Bearer ${rbsToken}` : '',
                    userId: userId || '',
                },
            };
        });
    }

    private http(): ApolloLink {
        const uri = `${environment.classSyncUrl}`;
        return this.httpLink.create({ uri });
    }

    private errorAfterware(): ApolloLink {
        return onError(({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                graphQLErrors.forEach(({
                    message,
                    locations,
                    path,
                }) => console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`));
            }
            if (networkError) {
                console.log(`[Network error]: ${networkError.message}`);
            }
        });
    }
}
